import { render, staticRenderFns } from "./fixo.vue?vue&type=template&id=3fbadbea"
var script = {}
import style0 from "./fixo.vue?vue&type=style&index=0&id=3fbadbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports